import DataKonsul from "@/services/DataKonsul";
import { SuratKonsulRanapItem, PasienKonsulRanapItem } from "@/types";
import DataList from "@/services/DataList";
import { storeSoap } from "@/store/modules/soap";
// import UserLogin from "@/utility/User";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { isNull } from "lodash";
import { userModule } from "./user";
import Service from "@/services/new/SuratKonsul";
// import { appModule } from "./app";

@Module({ store, dynamic: true, name: "surat-konsul-ranap" })
class SuratKonsulRanapStore extends VuexModule {
  listOnReg: Array<SuratKonsulRanapItem> = [];
  listPasienOnUnit: Array<PasienKonsulRanapItem> = [];
  loading = false;
  errlistkonsul = 0;

  @Mutation RESET_STORE() {
    this.listOnReg = [];
    this.loading = false;
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }

  @Mutation SET_LIST(list: Array<SuratKonsulRanapItem>) {
    this.listOnReg = list.filter(it => it.type == "konsul" && it.aktif == 1);
  }

  @Mutation SET_LIST_PASIEN(list: Array<PasienKonsulRanapItem>) {
    this.listPasienOnUnit = list.filter(
      it => it.type == "konsul" && it.aktif === 1
    );
  }

  @Mutation SET_LOADING(loading: boolean) {
    this.loading = loading;
  }

  @Action({ rawError: true })
  async getListKonsulByRegister(registerId: number) {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_LIST(response.data?.suratKonsul);
  }

  paramUnitId = null;
  paramSort = "-created_at";
  paramTglStart = null;
  paramTglEnd = null;

  @Mutation
  SET_PARAM_UNIT(val: string) {
    this.paramUnitId = val;
  }

  @Mutation
  SET_PARAM_SORT(val: string) {
    this.paramSort = val;
  }

  @Mutation
  SET_PARAM_TGL_START(val: string) {
    this.paramTglStart = val;
  }

  @Mutation
  SET_PARAM_TGL_END(val: string) {
    this.paramTglEnd = val;
  }

  @Mutation SET_ERR_LIST_KONSUL(errlistkonsul: number) {
    this.errlistkonsul = errlistkonsul;
  }

  @Action({ rawError: true })
  getListPasienKonsulRanap(params = null) {
    if (userModule.isSignedIn == true) {
      this.SET_LOADING(true);

      Service.getListKonsulRanap(this.paramUnitId, {
        sort: this.paramSort,
        tglStart: this.paramTglStart,
        tgllEnd: this.paramTglEnd
      })
        .then(resp => {
          console.log("get list pasien konsul ranap", resp);
          if (resp.status != 1) {
            this.SET_ERR_LIST_KONSUL(1);
          } else {
            this.SET_ERR_LIST_KONSUL(0);
            const listkonsul = resp.data;
            this.SET_LIST_PASIEN(listkonsul);
          }
        })
        .finally(() => {
          this.SET_LOADING(false);
        });
    }
  }
}

export const konsulRanapStore = getModule(SuratKonsulRanapStore);
